import { Button } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { setSessionStorageItem } from "../../utils/sessionStorageUtils";

import { getSessionStorageItem } from "../../utils/sessionStorageUtils.js";
import { SYSTEM_NOT_AVAILABLE } from "./MapConstants";
/*

      <p style={{ marginBottom: "5px", fontWeight: 400, fontSize: "14px" }}>
        Address : {selectedMarker?.address} 
      </p>
 selectedMarker?.devices?.length > 0 && (
          <>
            <p style={{ marginBottom: "-17px", fontWeight: 400, fontSize: "14px" }}>
              Systems : 
            </p>
            <ul style={{ listStyleType: 'none', paddingLeft: 70, marginBottom: '0px' }}>
              {
                selectedMarker?.systems?.map((system) => {
                  return (
                    <li style={{ paddingBottom: "5px", cursor: 'pointer' }} key={system.systemId}>
                      <a
                        href="/admin/dashboard"
                        onClick={(e) => {
                          e.preventDefault();

                          // Check if there are devices before storing session data
                          if (selectedMarker.devices.length > 0) {
                            const tenantSiteSystemDataToStore = []; 
                            const foundSite = selectedMarker?.tenant?.sites?.find(
                              (site) => site.siteName === selectedMarker.siteName
                            );

                            // Loop through the systems of the found site
                            selectedMarker?.systems?.map((system) =>  {
                              tenantSiteSystemDataToStore.push({
                                tenant: { 
                                  id: selectedMarker?.tenantId, name: selectedMarker.tenantName
                               },
                               site: { 
                                  id: selectedMarker?.siteId, name: selectedMarker.siteName
                               },
                               device: { 
                                   id: system.deviceId, name: system.deviceName 
                                },
                                system: {
                                  id: system?.systemId, // Assuming 'systemId' is the correct key for system ID
                                  name: system?.systemName, // Assuming 'systemName' is the correct key for system name
                                },
                              });
                            });
                           
                            // Remove duplicate tenant-site-system pairs, if any
                            const uniqueTenantSiteSystemData = tenantSiteSystemDataToStore.filter(
                              (value, index, self) =>
                                index ===
                                self.findIndex(
                                  (t) =>
                                    t.tenant.id === value.tenant.id &&
                                    t.site.id === value.site.id &&
                                    t.system.id === value.system.id &&
                                    t.device.id === value.device.id
                                )
                            );

                            // Now store the unique tenant-site-system data in session storage
                            setSessionStorageItem("haqt-selected-system", uniqueTenantSiteSystemData);
                            console.log(uniqueTenantSiteSystemData);
                           navigate("/admin/dashboard");
                          }
                        }}
                        style={{
                          textDecoration: "none",
                          fontWeight: 500,
                        }}
                      >
                        {system.systemName}
                      </a>
                    </li>
                  );
                })
              }
            </ul>
       
*/

const InfoWindowContent = ({ selectedMarker, onInfoStateChange }) => {
  const navigate = useNavigate();
  const tenantSiteSystemDataToStore = [];
  return (
    <div
      className="info-window-map"
      // Dheeraj Edit - added
      onMouseOver={() => {
        onInfoStateChange(true);
      }}
      onMouseOut={() => {
        onInfoStateChange(false);
      }}
    >
      <h5 style={{ fontSize: "16px" }}>
        {selectedMarker.tenantName} - {selectedMarker?.siteName}
      </h5>
      <p style={{ marginBottom: "5px", fontWeight: 400, fontSize: "14px" }}>
        Type : {selectedMarker?.siteType}
      </p>
      <p style={{ marginBottom: "5px", fontWeight: 400, fontSize: "14px" }}>
        Status :{" "}
        {selectedMarker?.devices?.length > 0
          ? selectedMarker?.devices[0].deviceStatus
          : SYSTEM_NOT_AVAILABLE}
      </p>
      {/* Dheeraj Edit - Changed 'System' to 'Device'*/}
      {selectedMarker?.systems?.length > 0 && (
        <p style={{ marginBottom: "-17px", fontWeight: 400, fontSize: "14px" }}>
          Device :
        </p>
      )}
      <ul
        style={{ listStyleType: "none", paddingLeft: 70, marginBottom: "0px" }}
      >
        {selectedMarker?.systems?.map((system) => {
          return (
            <li
              style={{ paddingBottom: "5px", fontWeight: 400 }} // Dheeraj Edit -  cursor: "pointer"
              key={system.systemId}
            >
              {system.systemName}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default InfoWindowContent;

// <a
//   href="/admin/dashboard"
//   onClick={(e) => {
//     e.preventDefault();
//     // need to add below code once we got systems from BE team
//     /* setSessionStorageItem('haqt-selected-system', {
//                     tenant: {
//                        id: selectedMarker?.tenantId, name: selectedMarker.tenantName
//                     },
//                     site: {
//                        id: selectedMarker?.siteId, name: selectedMarker.siteName
//                     },
//                     device: {
//                         id: system.deviceId, name: system.deviceName
//                      },
//                     system: {
//                        id: system?.systemId, name: system?.systemName
//                     },
//                   });*/
//     // Loop through the systems of the found site
//     /*
//                   selectedMarker?.systems?.map((system) =>  {
//                     tenantSiteSystemDataToStore.push({
//                       tenant: {
//                         id: selectedMarker?.tenantId, name: selectedMarker.tenantName
//                      },
//                      site: {
//                         id: selectedMarker?.siteId, name: selectedMarker.siteName
//                      },
//                      device: {
//                          id: system.deviceId, name: system.deviceName
//                       },
//                       system: {
//                         id: system?.systemId, // Assuming 'systemId' is the correct key for system ID
//                         name: system?.systemName, // Assuming 'systemName' is the correct key for system name
//                       },
//                     });
//                   });*/
//     /* const tenantSiteSystemData = {};
//                   if (selectedMarker) {
//                     const tenantId = selectedMarker?.tenantId;
//                     const tenantName = selectedMarker?.tenantName;

//                     // Initialize tenant if it doesn't exist
//                     if (!tenantSiteSystemData[tenantId]) {
//                       tenantSiteSystemData[tenantId] = {
//                         tenant: { id: tenantId, name: tenantName },
//                         sites: {}
//                       };
//                     }

//                     const siteId = selectedMarker?.siteId;
//                     const siteName = selectedMarker?.siteName;

//                     // Initialize site if it doesn't exist
//                     if (!tenantSiteSystemData[tenantId].sites[siteId]) {
//                       tenantSiteSystemData[tenantId].sites[siteId] = {
//                         site: { id: siteId, name: siteName },
//                         systems: []
//                       };
//                     }

//                     // Loop through the systems of the found site
//                     selectedMarker?.systems?.forEach(system => {
//                       tenantSiteSystemData[tenantId].sites[siteId].systems.push({
//                         id: system?.systemId,
//                         name: system?.systemName,
//                         device: { id: system.deviceId, name: system.deviceName }
//                       });
//                     });
//                   }

//                   // Convert the structure into a usable format (optional)
//                   const result = Object.values(tenantSiteSystemData).map(tenant => ({
//                     tenant: tenant.tenant,
//                     sites: Object.values(tenant.sites).map(site => ({
//                       site: site.site.id,
//                       name: site.site.name,
//                       systems: site.systems
//                     }))
//                   }));

//                   console.log("result:",result);*/

//     /* const tenantSiteSystemData = {};

// if (selectedMarker) {
//   const tenantId = selectedMarker?.tenantId;
//   const tenantName = selectedMarker?.tenantName;

//   // Initialize tenant if it doesn't exist
//   if (!tenantSiteSystemData[tenantId]) {
//     tenantSiteSystemData[tenantId] = {
//       id: tenantId,
//       name: tenantName,
//       Sites: {}
//     };
//   }

//   const siteId = selectedMarker?.siteId;
//   const siteName = selectedMarker?.siteName;

//   // Initialize site if it doesn't exist
//   if (!tenantSiteSystemData[tenantId].Sites[siteId]) {
//     tenantSiteSystemData[tenantId].Sites[siteId] = {
//       id: siteId,
//       name: siteName,
//       Systems: []
//     };
//   }

//   // Loop through the systems of the found site
//   selectedMarker?.systems?.forEach(system => {
//     tenantSiteSystemData[tenantId].Sites[siteId].Systems.push({
//       deviceId: system?.deviceId,
//       deviceName: system?.deviceName,
//       systemId: system?.systemId,
//       systemName: system?.systemName
//     });
//   });
// }

// // Convert the structure into the final format
// const result = {
//   Tenants: Object.values(tenantSiteSystemData).map(tenant => ({

//     sites: Object.values(tenant.Sites).map(site => ({
//       siteId: site.SiteId,
//       siteName: site.SiteName,
//       systems: site.Systems
//     })),
//     tenantId: tenant.TenantId,
//     tenantName: tenant.TenantName,
//   }))
// };

// // Convert to JSON string if needed
// const jsonString = JSON.stringify(tenantSiteSystemData);
// console.log("result:", jsonString);*/

//     const tenantSiteSystemData = {
//       tenants: [],
//     };

//     if (selectedMarker) {
//       const tenantId = selectedMarker?.tenantId;
//       const tenantName = selectedMarker?.tenantName;
//       const siteId = selectedMarker?.siteId;
//       const siteName = selectedMarker?.siteName;

//       // Find or create the tenant object
//       let tenant = tenantSiteSystemData.tenants.find(
//         (t) => t.TenantId === tenantId,
//       );

//       if (!tenant) {
//         tenant = {
//           id: tenantId,
//           name: tenantName,
//           sites: [],
//         };
//         tenantSiteSystemData.tenants.push(tenant);
//       }

//       // Find or create the site object
//       let site = tenant.sites.find((s) => s.SiteId === siteId);

//       if (!site) {
//         site = {
//           id: siteId,
//           name: siteName,
//           Systems: [],
//         };
//         tenant.sites.push(site);
//       }

//       // Add systems from selected marker
//       selectedMarker?.systems?.forEach((system) => {
//         site.Systems.push({
//           DeviceId: system?.deviceId,
//           SystemId: system?.systemId,
//           DeviceName: system?.deviceName,
//           SystemName: system?.systemName,
//         });
//       });
//     }

//     // Convert the structure into a JSON string
//     const result = JSON.stringify(tenantSiteSystemData);

//     // Output the result
//     console.log("result:", result);

//     // setSessionStorageItem(
//     //   "haqt-selected-system",
//     //   tenantSiteSystemData,
//     // );

//     setSessionStorageItem(
//       "haqt-selected-system",
//       selectedMarker.system.systemName,
//     );

//     const selectedMapData = getSessionStorageItem("haqt-selected-system");
//     console.log("selectedMapData", selectedMapData);
//     // navigate("/admin/dashboard"); // Dheeraj Edit - This is redundant
//   }}
//   style={{
//     textDecoration: "none",
//     fontWeight: 500,
//   }}
// >
//   {system.systemName}
// </a>;
